import { useTranslation } from 'react-i18next';
import closeIcone from '../NaviBar/icons/close.svg';
import noimg from '../../Icons/noimg.jpg';

const QRModal = (props) => {
  const { t } = useTranslation();
  const { show, setShow, code, machine, isLocal } = props;

  const qrcode = machine.themeColor?.allBrand
    ? isLocal
      ? `${process.env.REACT_APP_LOCAL_API}/pictures/machines/${machine.themeColor?.allBrand}`
      : `${process.env.REACT_APP_SERVER_API}/pictures/${machine.themeColor?.allBrand}/${machine.belongTo}`
    : noimg;

  const allProductImage = machine.themeColor?.allCate
    ? isLocal
      ? `${process.env.REACT_APP_LOCAL_API}/pictures/machines/${machine.themeColor?.allCate}`
      : `${process.env.REACT_APP_SERVER_API}/pictures/${machine.themeColor?.allCate}/${machine.belongTo}`
    : noimg;

  if (show) {
    return (
      // <Modal show={show} onHide={setCartFull(false)}>
      <div
        className="fullcart-modal main-container d-flex flex-column justify-content-start align-items-center"
        style={{ opacity: 1 }}
        // onClick={() => {
        //   setShow(false);
        // }}
      >
        <img
          src={closeIcone}
          className="privacy-close-icon"
          style={{ width: '80px' }}
          alt=""
          onClick={() => {
            setShow(false);
          }}
        ></img>
        <div
          className="homeProductText"
          style={{
            fontSize: '80px',
            width: '80%',
            marginBottom: '100px',
            marginTop: '200px',
          }}
        >
          {t('Scan QR code to get your eSIM')}
        </div>
        <img src=""></img>
        {/* <QRCode
          id="qr-preview"
          value={code}
          level={'H'}
          size={510}
          // includeMargin={true}
        /> */}
        <div style={{ width: '100%', height: '600px' }}>
          <img
            src={qrcode}
            className=""
            style={{ width: '100%', height: '100%', objectFit: 'contain' }}
            alt=""
            onClick={() => {}}
          ></img>
        </div>
        <div
          className="homeProductText"
          style={{
            fontSize: '80px',
            width: '80%',
            marginBottom: '40px',
            marginTop: '100px',
          }}
        >
          {t('Best Data Plans')}
        </div>

        <div>
          <img
            src={allProductImage}
            className=""
            style={{ width: '100%', height: '100%', objectFit: 'contain' }}
            alt=""
            onClick={() => {}}
          ></img>
        </div>
      </div>
    );
  } else return null;
};

export default QRModal;
